webpackJsonp([161354352423095],{

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Button = __webpack_require__(22);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//  Components
	
	
	var ExhibitTemplate = function (_React$Component) {
	  _inherits(ExhibitTemplate, _React$Component);
	
	  function ExhibitTemplate() {
	    _classCallCheck(this, ExhibitTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ExhibitTemplate.prototype.render = function render() {
	    var _props$pathContext = this.props.pathContext,
	        id = _props$pathContext.id,
	        title = _props$pathContext.title,
	        url = _props$pathContext.url,
	        parentPage = _props$pathContext.parentPage;
	
	
	    return _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/' + url + '-full.png'), alt: '' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(_Button2.default, { to: parentPage, text: 'Back' })
	          )
	        )
	      )
	    );
	  };
	
	  return ExhibitTemplate;
	}(_react2.default.Component);
	
	exports.default = ExhibitTemplate;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-exhibit-js-7d25a4152e06d26fcaf6.js